import api from './axios';

export interface College {
  id: number;
  college_code: string;
  college_name: string;
  college_type: string;
  district: {
    id: number;
    name: string;
  };
  naac_grade: string | null;
  autonomous_status: boolean;
  // Add other fields as needed
}

export interface CollegeSearchParams {
  page?: number;
  limit?: number;
  search?: string;
  college_type?: string;
  district_id?: number;
  naac_grade?: string;
  autonomous_status?: boolean;
  boys_hostel?: boolean;
  girls_hostel?: boolean;
  transport?: boolean;
}

export const collegeApi = {
  getAll: (params: CollegeSearchParams) => 
    api.get('/colleges', { params }),

  getById: (id: number) => 
    api.get(`/colleges/${id}`),

  getByCode: (code: string) => 
    api.get(`/colleges/code/${code}`),

  getCourses: (id: number, year?: number) => 
    api.get(`/colleges/${id}/courses`, { params: { year } }),

  compare: (college_ids: number[], year?: number) => 
    api.post('/colleges/compare', { college_ids, year }),

  predict: (data: {
    rank: number;
    community: string;
    branch_preference?: string[];
    year?: number;
  }) => api.post('/colleges/predict', data),
};

export default collegeApi;

